<template>
    <div id="Download" class="page" >
        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader bgColor="blue" @headerMenuClicked="menuClicked" page="download"></appHeader>

        <div id="CiteModalWrapper" :class="(citationModalDisplayed) ? 'displayed' : ''">
            <div id="CiteModalBg" @click="closeCitationModal()"></div>
            <div id="CiteModal">
                <div class="modal_closebt" @click="closeCitationModal()"></div>
                <div class="modal_title">How to cite ?</div>
                <div class="modal_text" v-html="citationModalText"></div>
                <div class="modal_buttons">
                    <div class="modal_bt" @click="updateModalText('text')" :class="(copiedType == 'text') ? 'copied' : ''">
                        <span class="copied_text">Copied</span>
                        <span class="bt_text">Copy text</span>
                    </div>
                    <div class="modal_bt" @click="updateModalText('apa')" :class="(copiedType == 'apa') ? 'copied' : ''">
                        <span class="copied_text">Copied</span>
                        <span class="bt_text">Copy APA</span>
                    </div>
                    <div class="modal_bt" @click="updateModalText('bip')" :class="(copiedType == 'bip') ? 'copied' : ''">
                        <span class="copied_text">Copied</span>
                        <span class="bt_text">Copy BipTex</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="main">
            <div class="main_inner">
                <section class="main_section">
                    <div class="section_content">
                        <h2 class="text_subtitle">-</h2>
                        <h1 class="title_page text_title2">
                            Download data & methodology
                        </h1>
                        <p class="text_p" style="margin-top: 24px;">
                            Here you will find complete annotated versions of the four datasets that make up the Atlas as well as detailed methodology notes that describe how each series was constructed.
                        </p>
                    </div>
                </section>

                <section class="main_section section_download" v-for="(downloadObj, briefIndex) in DBDownloads">
                    <div class="section_content">
                        <div class="content_title">{{downloadObj.title}}</div>
                        <div class="content_date">Last update {{downloadObj.date}}</div>
                        <div class="content_details">
                            <div class="content_image"><img :src="'/images/thumbnails/'+downloadObj.thumbnail" /></div>
                            <div class="content_desc">
                                <div class="desc_title">About this database:</div>
                                <div v-html="downloadObj.text"></div>
                                <div class="content_actionbar">
                                    <!--<a :href="'https://docs.google.com/spreadsheets/d/1BvOJE2PXytGyX1QnEOceOz3nYAu3zs1MqaCD76JGxNY/gviz/tq?tqx=out:csv&sheet=' + downloadObj.sheetName" target="_blank" class="actionbar_bt">Download data (.csv)</a>-->
                                    <a class="actionbar_bt" v-if="downloadObj.datasetID != null && DBDownloadsSheetObj[downloadObj.datasetID] != undefined" :href="DBDownloadsSheetObj[downloadObj.datasetID].data_link">Download data (.csv)</a>
                                    <a v-if="downloadObj.datasetID != null && DBDownloadsSheetObj[downloadObj.datasetID] != undefined" :href="DBDownloadsSheetObj[downloadObj.datasetID].methodo_link" class="actionbar_bt" data-bt="methodo">Download methodology</a>
                                    <a class="actionbar_bt" data-bt="cite" @click="displayCitationModal(downloadObj)">Cite</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div> 
        </div>
        <appFooter></appFooter>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "cookiesConsent": cookiesConsent
        },

        data: function () {
            return {
                isDataLoaded: false,
                loadingMethod: "csv",
                DBCountries: [],
                citationModalDisplayed: false,
                citationType: "text",
                citationModalText: "",
                citationModalDatasetID: "",
                DBDownloadsSheetObj: {},
                copiedType: "",
                DBDownloads: [
                    {
                        datasetID: "global-profit",
                        title: "Global profit shifting by multinational enterprises",
                        thumbnail: "icon_profit-shifting.png",
                        date: "15.05.2023",
                        text : "This database is an extention and update of the global profit shifting estimates originally derived in Tørsløv, Wier, and Zucman (2023). It presents, for the period 2015-2020 country level estimates of the total amount of profits shifted and tax revenue foregone away from losing countries, as well as estimates for the amount of profits shifted toward and tax revenue gained by tax haven countries.",
                        citations: {
                            "text":"<span class='bolder'>Dataset:</span><br />Tørsløv, T., Wier, L., Zucman, G., Gidron, I. (2024). Atlas of the Offshore World: Profit Shifting by Multinational Enterprises 2015-2021 (version November 2024). [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. <a href='https://www.atlas-offshore-world.org' target='_blank'>https://www.atlas-offshore-world.org</a><br /><br /><span class='bolder'>Academic baseline:</span><br />Tørsløv, T., Wier, L., Zucman, G. (2023). The Missing Profits of Nations. Review of Economic Studies, 90(3), 1499-1534. <a href='https://doi.org/10.1093/restud/rdac049' target='_blank'>https://doi.org/10.1093/restud/rdac049</a>",
                            "apa":"Dataset:Tørsløv, T., Wier, L., Zucman, G., & Gidron, I. (2024). Atlas of the Offshore World: Profit Shifting by Multinational Enterprises 2015-2021 (version November 2024) [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. https://www.atlas-offshore-world.org<br /><br />Academic baseline:Tørsløv, T., Wier, L., & Zucman, G. (2023). The Missing Profits of Nations. Review of Economic Studies, 90(3), 1499-1534. https://doi.org/10.1093/restud/rdac049",
                            "bip":"Dataset:<br />@dataset{torslov2024atlas,author = {Tørsløv, Thomas and Wier, Ludvig and Zucman, Gabriel and Gidron, Isaac},title = {Atlas of the Offshore World: Profit Shifting by Multinational Enterprises 2015-2021},year = {2024},version = {November 2024},publisher = {EU Tax Observatory, Skatteforsk - Centre for Tax Research},url = {https://www.atlas-offshore-world.org}<br />}<br /><br />Academic baseline:<br />@article{torslov2023missing,author = {Tørsløv, Thomas and Wier, Ludvig and Zucman, Gabriel},title = {The Missing Profits of Nations},journal = {Review of Economic Studies},volume = {90},number = {3},pages = {1499--1534},year = {2023},doi = {10.1093/restud/rdac049}}"},
                        sheetName: "Profit_shifting"
                    },
                    {
                        datasetID: "offshore-financial",
                        title: "Offshore financial wealth",
                        thumbnail: "icon_financial_wealth.png",
                        date: "15.05.2023",
                        text : "This database is an extention and update of the offshore financial wealth estimates originally derived in Zucman (2013) and in Alstadsæter, Johannesen and Zucman (2018). It presents, for the period 2001-2022 country level estimates of the total amount held abroad, as well as estimates for the amount hosted by countries classified as tax havens.",
                        citations: {
                            "text":"<span class='bolder'>Dataset:</span><br />Faye, S., Godar, S., Moura, C., Zucman, G. (2025). Atlas of the Offshore World: Offshore Financial Wealth 2001-2023 (version September 2025). [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. <a href='https://www.atlas-offshore-world.org' target='_blank'>https://www.atlas-offshore-world.org</a><br /><br /><span class='bolder'>Academic baseline:</span><br />Alstadsæter, A., Johannesen, N., Zucman, G. (2018). Who owns the wealth in tax havens? Macro evidence and implications for global inequality. Journal of Public Economics, 162, 89-100. <a href='https://doi.org/10.1016/j.jpubeco.2018.01.008' target='_blank'>https://doi.org/10.1016/j.jpubeco.2018.01.008</a>",
                            "apa":"Dataset:Faye, S., Godar, S., Moura, C., & Zucman, G. (2025). Atlas of the Offshore World: Offshore Financial Wealth 2001-2023 (version September 2025) [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. https://www.atlas-offshore-world.org<br /><br />Academic baseline:Alstadsæter, A., Johannesen, N., & Zucman, G. (2018). Who owns the wealth in tax havens? Macro evidence and implications for global inequality. Journal of Public Economics, 162, 89-100. https://doi.org/10.1016/j.jpubeco.2018.01.008",
                            "bip":"Dataset:<br />@dataset{faye2025atlas,<br />  author = {Faye, S{\'e}bastien and Godar, S{\'e}bastien and Moura, C{\'e}lia and Zucman, Gabriel},<br />  title = {Atlas of the Offshore World: Offshore Financial Wealth 2001-2023},<br />  year = {2025},<br />  version = {September 2025},<br />  publisher = {EU Tax Observatory, Skatteforsk - Centre for Tax Research},<br />  url = {https://www.atlas-offshore-world.org}<br />}<br /><br />Academic baseline:<br />@article{alstadsaeter2018owns, title={Who owns the wealth in tax havens? Macro evidence and implications for global inequality}, author={Alstads{\ae}ter, Annette and Johannesen, Niels and Zucman, Gabriel}, journal={Journal of Public Economics}, volume={162}, pages={89--100}, year={2018}, publisher={Elsevier} }",
                        },
                        sheetName: "Offshore_FW"
                    },
                    {
                        datasetID: "offshore-real-estate",
                        title: "Offshore real estate wealth",
                        thumbnail: "icon_real-estate.png",
                        date: "15.05.2023",
                        text : "The novel database on offshore real estate is the first to collect and present comprehensive estimates of offshore real estate in several important global cities. It supplements efforts using novel micro data on real estate ownership with data from a long list of different sources, including local statistical agencies, consultancy firms and researchers.<br /><br />",
                        citations: {
                            "text":"<span class='bolder'>Dataset:</span><br /><br />Alstadsæter, A., Collin, M., Mishra, K., Planterose, B., Zucman, G., Økland, A. (2024). Atlas of the Offshore World: Offshore Real Estate in 7 cities and areas 2019 (version November 2024). [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. <a href='https://www.atlas-offshore-world.org' target='_blank'>https://www.atlas-offshore-world.org</a>",
                            "apa":"Alstadsæter, A., Collin, M., Mishra, K., Planterose, B., Zucman, G., & Økland, A. (2024). Atlas of the Offshore World: Offshore Real Estate in 7 cities and areas 2019 (version November 2024) [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. https://www.atlas-offshore-world.org",
                            "bip":"@dataset{alstadsaeter2024atlas,author = {Alstadsæter, Annette and Collin, Martin and Mishra, Katarzyna and Planterose, Beatriz and Zucman, Gabriel and Økland, Andreas},title = {Atlas of the Offshore World: Offshore Real Estate in 7 cities and areas 2019},year = {2024},version = {November 2024},publisher = {EU Tax Observatory, Skatteforsk - Centre for Tax Research},url = {https://www.atlas-offshore-world.org}}"
                        },
                        sheetName: "Offshore_RE"
                    },
                    {
                        datasetID: "effective-tax",
                        title: "Effective tax rates on capital and labor",
                        thumbnail: "icon_effective-tax-rates.png",
                        date: "15.05.2023",
                        text : "The database on effective tax rates presents long-run estimates of effective factor taxation at the country level, between 1965 and 2021. It updates the work of Bachas, Fisher-Post, Jensen, and Zucman (2022), which stops in 2018. It is based on data from disaggregated tax revenue and national income components for over 150 countries. The tax revenue data draws from four sources: the OECD online Government Revenue Statistics; the ICTD/UNU-WIDER Government Revenue Dataset; the IMF Government Finance Statistics Historical Database; and, individual country archives. The factor share data combines the SNA2008 online data with the SNA1968 archival material.",
                        citations: {
                            "text":"<span class='bolder'>Dataset:</span><br />Bachas, P., Moriana-Armendariz, X. (2024). Atlas of the Offshore World: Effective Tax Rates on Capital and Labor 1965-2021 (version November 2024) [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. <a href='https://www.atlas-offshore-world.org' target='_blank'>https://www.atlas-offshore-world.org</a><br /><br /><span class='bolder'>Academic baseline:</span><br />Bachas, P., Fisher-Post, M. H., Jensen, A., Zucman, G. (2023). Globalization and factor income taxation, Working paper RWP23-027, Harvard Kennedy School. <a href='https://doi.org/10.2139/ssrn.4555395' target='_blank'>https://doi.org/10.2139/ssrn.4555395</a>",
                            "apa":"Dataset:Bachas, P., Moriana-Armendariz, X. (2024). Atlas of the Offshore World: Effective Tax Rates on Capital and Labor 1965-2021 (version November 2024) [Dataset]. EU Tax Observatory, Skatteforsk - Centre for Tax Research. https://www.atlas-offshore-world.org",
                            "bip":"@dataset{bachas2024atlas,author = {Bachas, Pierre and Moriana-Armendariz, Xabier},title = {Atlas of the Offshore World: Effective Tax Rates on Capital and Labor 1965-2021},year = {2024},version = {November 2024},publisher = {EU Tax Observatory, Skatteforsk - Centre for Tax Research},url = {https://www.atlas-offshore-world.org}}Academic baseline:@article{bachas2023globalization,author = {Bachas, Pierre and Fisher-Post, Matthew H and Jensen, Anders and Zucman, Gabriel},title = {Globalization and factor income taxation},journal = {Working paper RWP23-027},year = {2023},publisher = {Harvard Kennedy School} }"
                        },
                        sheetName: "Effective_tax_rate"
                    },
                    /*
                    {
                        datasetID: "countries",
                        title: "Country database",
                        date: "15.05.2023",
                        thumbnail: "thumbnail-dataset-country@2x.png",
                        text : "dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.",
                        sheetName: "country_metadata"
                    }
                    */
                ],
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this; 
            //if(location.host == "staging-eu-tax-observatory.wedodata.dev") this.loadingMethod = "gsheet";

            if(this.loadingMethod == "csv"){
                this.loadStaticCSVData();
            } else {
                this.loadStaticSpreadsheetData();
            }
        },

        methods: {
            loadStaticSpreadsheetData: function (){
                var self = this;
                UTILS.loadDownloadSpreadsheetData().then(function (callbackStatic){
                    console.log("callbackStatic", callbackStatic);
                    _.each(callbackStatic, function (obj){
                        self.DBDownloadsSheetObj[obj.dataset] = {
                            methodo_link: self.normalizeDropboxDownloadUrl(obj.methodo_link),
                            data_link: self.normalizeDropboxDownloadUrl(obj.data_link)
                        }
                    })
                    console.log("DBDownloadsSheetObj", self.DBDownloadsSheetObj);
                    self.loadCountriesMetadata();
                })
            },

            loadStaticCSVData: function (){
                var self = this;
                UTILS.loadDownloadCSVData().then(function (callbackStatic){
                    console.log("callbackStatic loadStaticCSVData", callbackStatic);
                    _.each(callbackStatic, function (obj){
                        if(obj.dataset != undefined){
                            self.DBDownloadsSheetObj[obj.dataset] = {
                                methodo_link: self.normalizeDropboxDownloadUrl(obj.methodo_link),
                                data_link: self.normalizeDropboxDownloadUrl(obj.data_link)
                            }
                        }
                        
                    })
                    console.log("DBDownloadsSheetObj", self.DBDownloadsSheetObj);
                    self.loadCountriesCSVMetadata();
                })
            },

            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesSpreadsheetData().then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            loadCountriesCSVMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            truncate(text) {
              return `${text.substring(0, this.briefTextLimit)}...`;
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },

            /**
             * Dropbox shared links with raw=1 can fail in Microsoft Edge when opened in a new tab.
             * Force dl=1 and drop raw so the response is a proper download; keep rlkey/st params.
             */
            normalizeDropboxDownloadUrl: function (url) {
                if (!url || typeof url !== 'string') return url;
                if (!/dropbox\.com\//i.test(url)) return url;
                try {
                    var u = new URL(url);
                    u.searchParams.delete('raw');
                    u.searchParams.set('dl', '1');
                    return u.toString();
                } catch (e) {
                    return url;
                }
            },

            displayCitationModal: function (downloadObj){
                this.citationModalText = downloadObj.citations[this.citationType];
                this.citationModalDisplayed = true;
                this.citationModalDatasetID = downloadObj.datasetID;
            },

            closeCitationModal: function (){
                this.citationModalDisplayed = false;
                this.citationType = "text";
                this.copiedType = "";
            },

            updateModalText: function (citationType){
                var self = this;

                this.citationType = citationType;
                var downloadObj = _.find(this.DBDownloads, function (o){
                    return o.datasetID == self.citationModalDatasetID;
                })
                this.citationModalText = downloadObj.citations[this.citationType];
                // Use the Clipboard API to copy the text
                navigator.clipboard.writeText(this.citationModalText).then(function() {
                    setTimeout(function (){
                        self.copiedType = citationType;
                    }, 300)

                    setTimeout(function (){
                        self.copiedType = "";
                    }, 2000)
                    
                    console.log('Text copied to clipboard successfully!');
                }).catch(function(err) {
                    console.error('Could not copy text: ', err);
                });
            }
        },

        watch: {

        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #Download{
        #CiteModalWrapper{
            position: fixed;
            left: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            z-index: 1000000;
            display: none;
            &.displayed{
                display: block;
            }
            #CiteModalBg{
                background: rgba(46, 91, 176, 0.90);
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
                z-index: 1;
            }
            #CiteModal{
                background: #191637;
                width: 524px;
                padding: 32px 44px 32px 32px;
                border-radius: 20px;
                color: #fff;
                position: absolute;
                z-index: 10;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                text-align: left;
                .modal_closebt{
                    position: absolute;
                    background: url("/images/bt-close.svg") no-repeat 0 0;
                    background-size: 100% 100%;
                    width: 20px;
                    height: 20px;
                    right: 44px;
                    top: 32px;
                    cursor: pointer;
                }
                .modal_title{
                    font-family: "Roboto";
                    font-size: 16px;
                    letter-spacing: 1.2px;
                }
                .modal_text{
                    text-align: left;
                    margin-top: 12px;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    .bolder{
                        font-weight: 700;
                    }
                }
                .modal_buttons{
                    text-align: left;
                    margin-top: 24px;
                    .modal_bt{
                        background: #fff;
                        border-radius: 32px;
                        height: 32px;
                        line-height: 28px;
                        cursor: pointer;
                        margin-right: 10px;
                        color: #164193;
                        font-size: 14px;
                        position: relative;
                        display: inline-block;
                        padding: 0 30px 0 12px;
                        border: 2px solid #fff;
                        &:after{
                            content: "";
                            position: absolute;
                            right: 8px;
                            top: 50%;
                            transform: translate(0, -50%);
                            background: url("/images/bt-copy.svg") no-repeat 0 0;
                            background-size: 100% 100%;
                            width: 20px;
                            height: 20px;
                        }
                        &:hover{
                            background: #164193;
                            color: #fff;
                            border: 2px solid #164193;
                            &:after{
                                background: url("/images/bt-copy-white.svg") no-repeat 0 0;
                                background-size: 100% 100%;
                            }
                        }
                        &.copied{
                            background: transparent !important;
                            border: 2px solid #164193 !important;
                            &:after{
                                background: url("/images/bt-copy-white.svg") no-repeat 0 0 !important;
                                background-size: 100% 100%;
                            }
                            .bt_text{
                                visibility: hidden;
                            }
                            .copied_text{
                                display: block;
                            }
                        }
                        .copied_text{
                            position: absolute;
                            left: 12px;
                            top: 50%;
                            color: #fff;
                            display: none;
                            transform: translate(0, -50%);
                        }
                    }
                }
            }
        }
    }

    #Download .main{
        background: #fff;
        .main_section{
             &.section_download{
                padding: 50px 0 60px;
                background: linear-gradient(180deg, #EEF1F6 0%, rgba(238, 241, 246, 0.00) 100%);
                .content_title{
                    font-size: 32px;
                    color: $colorBlue;
                    letter-spacing: 3.2px;
                    font-weight: 400;
                    border-top: 4px solid $colorBlue;
                    padding-top: 10px;
                }
                .content_date{
                    font-size: 12px;
                    color: $colorBlue;
                    letter-spacing: 0.6px;
                    margin-top: 10px;
                }
                .content_details{
                    margin-top: 10px;
                    .content_image{
                        display: inline-block;
                        vertical-align: top;
                        width: 232px;
                        img{
                            position: relative;
                            top: 5px;
                            width: 100%;
                        }
                    }
                    .content_desc{
                        display: inline-block;
                        vertical-align: top;
                        width: 670px;
                        font-size: 18px;
                        line-height: 170%;
                        color: $colorBlack;
                        margin-left: 16px;
                        .desc_title{
                            font-weight: 700;
                        }
                        .content_actionbar{
                            text-align: left;
                            position: relative;
                            width: 100%;
                            height: 24px;
                            margin-top: 20px;
                            .actionbar_bt{
                                background: $colorBlue;
                                color: #fff;
                                height: 32px;
                                line-height: 32px;
                                padding: 0 34px 0 12px;
                                border-radius: 32px;
                                font-size: 14px;
                                border: 0px solid;
                                cursor: pointer;
                                position: relative;
                                display: inline-block;
                                margin-right: 10px;
                                text-decoration: none;
                                &:after{
                                    content: "";
                                    position: absolute;
                                    right: 5px;
                                    top: 50%;
                                    transform: translate(0, -50%);
                                    background: url("/images/download.svg") no-repeat 0 0;
                                    background-size: 100% 100%;
                                    width: 21px;
                                    height: 20px;
                                }
                                &[data-bt="methodo"]{
                                    &:after{
                                        background: url("/images/files.svg") no-repeat 0 0;
                                        background-size: 100% 100%;
                                    }
                                }
                                &[data-bt="cite"]{
                                    &:after{
                                        background: url("/images/cite.svg") no-repeat 0 0;
                                        background-size: 100% 100%;
                                        width: 14px;
                                        height: 14px;
                                        right: 10px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

   
</style>



// WEBPACK FOOTER //
// pages/download-data/index.vue